<div class="input-wrapper" >
    <label class="input-label" *ngIf="label">{{label}}</label>
    <input [id]="id" class="text-input" type="text"
        [(ngModel)]="text"
        [disabled]="disabled"/>
</div>